export default "__VITE_ASSET__BC$JwQsi__"